'use strict';

var React = require('react');

var SvgFolderMinusMajor = function SvgFolderMinusMajor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M4.5 6.75c0-.69.56-1.25 1.25-1.25h1.514c.473 0 .906.268 1.118.691l.17.342a1.75 1.75 0 0 0 1.566.967h4.132c.69 0 1.25.56 1.25 1.25v.5a.75.75 0 0 0 1.5 0v-.5a2.75 2.75 0 0 0-2.75-2.75h-4.132a.25.25 0 0 1-.224-.138l-.17-.342a2.75 2.75 0 0 0-2.46-1.52h-1.514a2.75 2.75 0 0 0-2.75 2.75v6.5a2.75 2.75 0 0 0 2.75 2.75h7a.75.75 0 0 0 0-1.5h-7c-.69 0-1.25-.56-1.25-1.25v-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.5a.75.75 0 0 0 0 1.5h4.5a.75.75 0 0 0 0-1.5h-4.5Z"
  }));
};
SvgFolderMinusMajor.displayName = "FolderMinusMajor";

exports.SvgFolderMinusMajor = SvgFolderMinusMajor;
